import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class AuthProviderService {
  async init() {
    return (await fetchApi.get(`/authProvider`)).data;
  }

  async getList() {
    return (await fetchApi.get(`/authProvider/list`)).data;
  }

  async getIDP(idpId) {
    return (await fetchApi.get(`/authProvider/${idpId}`)).data;
  }

  async createIDP(data) {
    return (await fetchApi.post(`/authProvider`, data)).data;
  }

  async createOIDCIDP(data) {
    return (await fetchApi.post(`/authProvider/oidc`, data)).data;
  }

  async updateSAMLIDPMetadata(idpId, data) {
    return (await fetchApi.patch(`/authProvider/${idpId}/metadata`, data)).data;
  }

  async updateOIDCIDPMetadata(idpId, data) {
    return (await fetchApi.patch(`/authProvider/oidc/${idpId}/metadata`, data)).data;
  }

  async updateIDP(idpId, data) {
    return (await fetchApi.patch(`/authProvider/${idpId}`, data)).data;
  }

  async updateOIDCIDP(idpId, data) {
    return (await fetchApi.patch(`/authProvider/oidc/${idpId}`, data)).data;
  }

  async downloadXML(idpId) {
    return await fetchApi.download(`/authProvider/${idpId}/download`, {
      fileName: "metadata.xml",
    });
  }

  async deleteIDP(idpId) {
    return (await fetchApi.delete(`/authProvider/${idpId}`)).data;
  }
}
